import React, { useState } from 'react'
import Typography from '@material-ui/core/Typography'
import { Button, Grid, Card, CardContent, CardActions, CircularProgress } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { hubjectStyles } from './HubjectStyles'
import { ConfirmationDialog } from '../../shared/components/confirmationDialog'
import { config, getToken } from '../../config'
import ReactJson from 'react-json-view'
import { useSelector } from 'react-redux'

export default function Hubject() {
    const classes = hubjectStyles()
    const { t } = useTranslation()
    
    const tenantId = useSelector((state: any) => state.login.value.user.tenantId)

    const [isPerformFullloadConfirmationOpened, setIsPerformFullloadConfirmationOpened] = useState(false)
    const [isPerformDeleteConfirmationOpened, setIsPerformDeleteConfirmationOpened] = useState(false)

    const [isPerformFullloadInProgress, setIsPerformFullloadInProgress] = useState(false)
    const [isPerformDeleteInProgress, setIsPerformDeleteInProgress] = useState(false)

    const [fullloadData, setFullloadData] = useState<any>({ result: t('hubject.notExecuted') })
    const [deleteData, setDeleteData] = useState<any>({ result: t('hubject.notExecuted') })

    const performFullloadController = new AbortController()
    const performDeleteController = new AbortController()

    const handlePerformFullload = () => {
        if (isPerformFullloadInProgress) {
            return
        }
        setIsPerformFullloadInProgress(true)

        fetch(`${config.api}_OICP/eRoamingPushEvseDataFullload`, {
            signal: performFullloadController.signal,
            method: 'POST',
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        })
            .then((res) => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw res.statusText
                }
            })
            .then((data: any) => {
                setFullloadData(data)
            })
            .catch((error) => {
                setFullloadData({ error })
            })
            .finally(() => {
                setIsPerformFullloadInProgress(false)
                setIsPerformFullloadConfirmationOpened(false)
            })
    }

    const handlePerformDelete = () => {
        if (isPerformDeleteInProgress) {
            return
        }
        setIsPerformDeleteInProgress(true)

        fetch(`${config.api}_OICP/eRoamingPushEvseDataDeleteAll`, {
            signal: performFullloadController.signal,
            method: 'POST',
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
        })
            .then((res) => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw res.statusText
                }
            })
            .then((data: any) => {
                setDeleteData(data)
            })
            .catch((error) => {
                setDeleteData({ error })
            })
            .finally(() => {
                setIsPerformDeleteInProgress(false)
                setIsPerformDeleteConfirmationOpened(false)
            })
    }

    return (
        <>
            <ConfirmationDialog
                open={isPerformFullloadConfirmationOpened}
                onConfirm={handlePerformFullload}
                onCancel={() => {
                    if (isPerformFullloadInProgress) {
                        performFullloadController.abort()
                        setIsPerformFullloadInProgress(false)
                    }
                    setIsPerformFullloadConfirmationOpened(false)
                }}
                title={t('hubject.areyousure')}
                confirmLabel={t('common.yes')}
                inProgress={isPerformFullloadInProgress}
                content={t('hubject.confirmPerformFullload')}
                cancelLabel={t('common.no')}
            />
            <ConfirmationDialog
                open={isPerformDeleteConfirmationOpened}
                onConfirm={handlePerformDelete}
                onCancel={() => {
                    if (isPerformDeleteInProgress) {
                        performDeleteController.abort()
                        setIsPerformDeleteInProgress(false)
                    }
                    setIsPerformDeleteConfirmationOpened(false)
                }}
                title={t('hubject.areyousure')}
                confirmLabel={t('common.yes')}
                inProgress={isPerformDeleteInProgress}
                content={t('hubject.deleteAllRecords')}
                cancelLabel={t('common.no')}
            />
            <Grid container className={classes.content}>
                <Grid item xs={12} className={classes.headerWrapper}>
                    <Typography align="left" variant="h3">
                        {t('hubject.title')}
                    </Typography>
                </Grid>

                {/* kazda akcia ako samostatna karta: popis, tlacidlo, posledny vysledok */}
                <Grid item xs={12} className={classes.cards}>
                    <Card className={classes.card} elevation={1}>
                        <CardContent className={classes.cardContent}>
                            <Typography variant="h6">{t('hubject.fullloadTitle')}</Typography>
                            <Typography variant="body2" color="textSecondary" className={classes.description}>
                                {t('hubject.fullloadDescription')}
                            </Typography>
                            <Typography variant="subtitle2" className={classes.resultLabel}>
                                {t('hubject.lastResult')}
                            </Typography>
                            <div className={classes.result}>
                                {isPerformFullloadInProgress ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    fullloadData && (
                                        <ReactJson
                                            src={fullloadData}
                                            name={false}
                                            iconStyle="square"
                                            enableClipboard={false}
                                            displayObjectSize={false}
                                            displayDataTypes={false}
                                            collapsed={2}
                                        />
                                    )
                                )}
                            </div>
                        </CardContent>
                        <CardActions className={classes.cardActions}>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={isPerformFullloadInProgress}
                                onClick={() => {
                                    setIsPerformFullloadConfirmationOpened(true)
                                }}
                            >
                                {t('hubject.performFullload')}
                            </Button>
                        </CardActions>
                    </Card>

                    {tenantId && tenantId === config.mainTenantId && (
                        <Card className={classes.card} elevation={1}>
                            <CardContent className={classes.cardContent}>
                                <Typography variant="h6">{t('hubject.deleteTitle')}</Typography>
                                <Typography variant="body2" color="textSecondary" className={classes.description}>
                                    {t('hubject.deleteDescription')}
                                </Typography>
                                <Typography variant="subtitle2" className={classes.resultLabel}>
                                    {t('hubject.lastResult')}
                                </Typography>
                                <div className={classes.result}>
                                    {isPerformDeleteInProgress ? (
                                        <CircularProgress size={24} />
                                    ) : (
                                        deleteData && (
                                            <ReactJson
                                                src={deleteData}
                                                name={false}
                                                iconStyle="square"
                                                enableClipboard={false}
                                                displayObjectSize={false}
                                                displayDataTypes={false}
                                                collapsed={2}
                                            />
                                        )
                                    )}
                                </div>
                            </CardContent>
                            <CardActions className={classes.cardActions}>
                                <Button
                                    variant="outlined"
                                    className={classes.dangerButton}
                                    disabled={isPerformDeleteInProgress}
                                    onClick={() => {
                                        setIsPerformDeleteConfirmationOpened(true)
                                    }}
                                >
                                    {t('hubject.deleteAllRecords')}
                                </Button>
                            </CardActions>
                        </Card>
                    )}
                </Grid>
            </Grid>
        </>
    )
}
